module.exports = __webpack_public_path__ + "img/Last image OOBE Polish.b1d471af.png";